module.exports = __webpack_public_path__ + "media/森林.71983838.mp4";